import { useEffect } from "react";
import { useState } from "react";
import Header from "../components/Header/Header";
import MainContentWrapper from "../components/Wrappers/MainContentWrapper";
import ScreenWrapper from "../components/Wrappers/ScreenWrapper";
import { useAuthContext } from "src/context/authContext";
import { useNavigate } from "react-router-dom";
import { configure } from "src/Utilities/configure";
import useCfgURLParams from "src/customHooks/useCfgURLParams";


export default function AuthLandingPage() {
    const navigate = useNavigate();
    const { isCommunity } = useAuthContext();
    const [acrValue, setAcrValue] = useState(null);
    const [qsParams, setQsParams] = useState('');

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const gotoParams = new URLSearchParams(params.get('goto'));
        configure(useCfgURLParams());

        if (gotoParams.get('locale')) {
            params.set('locale', gotoParams.get('locale'));
        }
        setQsParams(params.toString());

        if (gotoParams.get('acr')) {
            setAcrValue(gotoParams.get('acr'));
        }
        else {
            // TODO: Support brand if passed to allow community login
            // Default to login
            navigate({
                pathname: "/user/login",
                search: params.toString()
            });
        }
    }, []);

    useEffect(() => {
        // TODO: Refactor brand to store supplied brand instead of isCommunity boolean
        const brand = isCommunity ? 'community' : 'pm';

        if (acrValue) {
            const route = mapTargetRoute(acrValue, brand);
            navigate({
                pathname: route,
                search: qsParams
            });
        }
    }, [acrValue]);

    const mapTargetRoute = (acrValue, brand) => {
        if (brand === 'community') {
            switch (acrValue) {
                case "login":
                    return "/user/community-login";
                case "register":
                    return "/user/community-register";
                case "login_oidc":
                    return "/user/primSSO";
                case "loa2":
                    return "/user/loa2";
                case "activation":
                    return "/user/activation";
                case "activate":
                    return "/user/activate";                    
                default:
                    return "/user/error";
            }
        }
        else { // if (brand === 'pm')
            switch (acrValue) {
                case "login":
                    return "/user/login";
                case "register":
                    return "/user/register";
                case "comreg":
                    return "/user/community-register";
                case "login_oidc":
                    return "/user/primSSO";
                case "loa2":
                    return "/user/loa2";
                case "loa2pm":
                    return "/user/loa2pm";
                case "khoros":
                    return "/user/khoros";
                case "activation":
                    return "/user/activation";
                case "activate":
                    return "/user/activate";                    
                default:
                    return "/user/error";
            }
        }
    };

    return (
        <ScreenWrapper>
            <Header/>
            <MainContentWrapper>
                {/* TODO: Render Loading animation */}
                <p> </p>
            </MainContentWrapper>
        </ScreenWrapper>
    );
}
